import LookUpModel from "./LookUpModel";

export default class AuthorityTypeModel extends LookUpModel {
    constructor(data: Partial<AuthorityTypeModel>) {
        super(data);

        this.update(data);
    }
}
